import { IAppSettings } from '../types';

const getAppSettings = async (): Promise<IAppSettings> => {
  return fetch('../public/app.settings.json', { cache: 'no-store' }).then((response) =>
    response.json()
  );
};

export const appSettings = await getAppSettings();
